/* ============================================================
   FUSSION LANDING — JavaScript
   Archivo: assets/fussion-landing.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* Este archivo se incluye dos veces (hero + content). Evitamos
     duplicar cursor, partículas y observers. El parallax de la
     galería NO está aquí: vive en sections/fussion-content.liquid */
  if (window.__fussionLandingInit) return;
  window.__fussionLandingInit = true;

  /* ─── CURSOR ─── */
  const curEl = document.getElementById('fussion-cursor') || document.getElementById('cursor');
  const cringEl = document.getElementById('fussion-cring') || document.getElementById('cring');
  if (curEl && cringEl) {
    let mx=0,my=0,rx=0,ry=0;
    document.addEventListener('mousemove', e => {
      mx=e.clientX; my=e.clientY;
      curEl.style.left=mx+'px'; curEl.style.top=my+'px';
    });
    (function tickC(){
      rx+=(mx-rx)*.12; ry+=(my-ry)*.12;
      cringEl.style.left=rx+'px'; cringEl.style.top=ry+'px';
      requestAnimationFrame(tickC);
    })();
    document.querySelectorAll('a,button').forEach(el=>{
      el.addEventListener('mouseenter',()=>{ curEl.style.transform='translate(-50%,-50%) scale(2.2)'; cringEl.style.width='56px'; cringEl.style.height='56px'; });
      el.addEventListener('mouseleave',()=>{ curEl.style.transform='translate(-50%,-50%) scale(1)'; cringEl.style.width='32px'; cringEl.style.height='32px'; });
    });
  }

  /* ─── PARTICLES ─── */
  const pc = document.getElementById('fussion-pcanvas') || document.getElementById('pcanvas');
  if (pc) {
    const px = pc.getContext('2d');
    function resPC(){ pc.width=window.innerWidth; pc.height=window.innerHeight; }
    resPC(); window.addEventListener('resize', resPC);

    const PLIGHT=['rgba(123,53,216,.1)','rgba(182,108,255,.08)','rgba(0,180,180,.07)'];
    const PDARK=['rgba(0,212,212,.3)','rgba(182,108,255,.22)','rgba(255,255,255,.13)'];
    let ppalette=PLIGHT;

    const parts=[];
    for(let i=0;i<60;i++){
      parts.push({
        x:Math.random()*window.innerWidth,
        y:Math.random()*window.innerHeight,
        r:Math.random()*1.5+.3,
        vx:(Math.random()-.5)*.26,
        vy:-(Math.random()*.42+.07),
        ci:Math.floor(Math.random()*3)
      });
    }

    (function drawP(){
      px.clearRect(0,0,pc.width,pc.height);
      parts.forEach(p=>{
        px.beginPath();
        px.arc(p.x,p.y,p.r,0,Math.PI*2);
        px.fillStyle=ppalette[p.ci];
        px.fill();
        p.x+=p.vx; p.y+=p.vy;
        if(p.y<-10){p.y=pc.height+10; p.x=Math.random()*pc.width;}
        if(p.x<-10) p.x=pc.width+10;
        if(p.x>pc.width+10) p.x=-10;
      });
      requestAnimationFrame(drawP);
    })();

    window._fussionPpalette = function(dark){ ppalette = dark ? PDARK : PLIGHT; };
  }

  /* ─── SCROLL REVEAL ─── */
  const rvObs = new IntersectionObserver(entries => entries.forEach(e => {
    if(e.isIntersecting) e.target.classList.add('on');
  }), {threshold:.1});
  document.querySelectorAll('.rv').forEach(el => rvObs.observe(el));

  /* ─── SYNC TAMAÑO (59mm) ⇄ BOX PORTERO ───
     Si el cliente elige la talla 59mm directamente en el selector nativo
     de Shopify (Tamaño), el box de la derecha pasa a "Portero". Si elige
     cualquier otra talla, el box vuelve a "Jugador". El sentido inverso
     (click en el box) lo maneja selectWheel() más abajo. */
  const FUSSION_SIZES = ['80mm','76mm','72mm','68mm','59mm'];

  function fussionSizeText(inp){
    const lbl = document.querySelector('label[for="' + inp.id + '"]');
    return (lbl ? lbl.textContent : inp.value).trim().toLowerCase();
  }

  function syncBoxFromSize(sizeText){
    const goalie = sizeText === '59mm';
    document.body.classList.toggle('accent-cyan', goalie);
    document.querySelectorAll('.woption').forEach(el =>
      el.classList.toggle('active', el.dataset.w === (goalie ? 'goalie' : 'player'))
    );
  }

  document.querySelectorAll('.variant-input input[type="radio"], fieldset input[type="radio"]').forEach(function(inp){
    const text = fussionSizeText(inp);
    if (FUSSION_SIZES.indexOf(text) === -1) return; /* no es un input de Tamaño */

    if (inp.checked) syncBoxFromSize(text); /* estado inicial al cargar la página */

    inp.addEventListener('change', function(){ syncBoxFromSize(text); });
  });

});

/* ─── HELPERS GLOBALES (usados por selectWheel) ─── */
function clickSilent(el){
  const orig = el.scrollIntoView;
  el.scrollIntoView = function(){};
  el.click();
  el.scrollIntoView = orig;
}

function selectVariantByText(text){
  let found = false;
  document.querySelectorAll('.variant-input label, fieldset label').forEach(function(lbl){
    if(lbl.textContent.trim().toLowerCase() === text){
      clickSilent(lbl);
      found = true;
    }
  });
  if(!found){
    document.querySelectorAll('input[type="radio"]').forEach(function(inp){
      const lbl = document.querySelector('label[for="' + inp.id + '"]');
      const t = lbl ? lbl.textContent.trim().toLowerCase() : inp.value.trim().toLowerCase();
      if(t === text){
        clickSilent(inp);
        inp.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
  }
  return found;
}

function fussionCurrentSizeIsGoalie(){
  return Array.from(document.querySelectorAll('input[type="radio"]:checked')).some(function(inp){
    const lbl = document.querySelector('label[for="' + inp.id + '"]');
    const text = lbl ? lbl.textContent.trim().toLowerCase() : inp.value.trim().toLowerCase();
    return text === '59mm';
  });
}

/* ─── WHEEL SELECTOR — global ─── */
function selectWheel(mode){
  /* 1. Activar opción visual */
  document.querySelectorAll('.woption').forEach(el =>
    el.classList.toggle('active', el.dataset.w === mode)
  );

  /* 2. Cambio de acento (cyan en portero, purpura en jugador) — sin fondo oscuro */
  const goalie = mode === 'goalie';
  document.body.classList.toggle('accent-cyan', goalie);

  /* Guardar posición de scroll antes del click */
  const scrollX = window.pageXOffset;
  const scrollY = window.pageYOffset;

  /* 3. Auto-seleccionar Modelo (se mantiene igual que antes) */
  selectVariantByText(goalie ? 'fussion g' : 'fussion');

  /* 4. Auto-seleccionar Tamaño: Portero -> siempre 59mm.
        Jugador -> solo si la talla actual era 59mm (para no tocar
        una talla de jugador ya elegida, ej. 76mm) */
  if(goalie){
    selectVariantByText('59mm');
  } else if(fussionCurrentSizeIsGoalie()){
    selectVariantByText('80mm');
  }

  /* Restaurar scroll — 3 veces para cubrir cualquier async de Shopify */
  window.scrollTo(scrollX, scrollY);
  setTimeout(function(){ window.scrollTo(scrollX, scrollY); }, 0);
  setTimeout(function(){ window.scrollTo(scrollX, scrollY); }, 80);
  setTimeout(function(){ window.scrollTo(scrollX, scrollY); }, 200);
}